// extracted by mini-css-extract-plugin
export var container = "_4x-0";
export var fallback = "_4x-5";
export var fallbackIcon = "_4x-6";
export var hidden = "_4x-2";
export var image = "_4x-3";
export var loaded = "_4x-4";
export var placeholder = "_4x-1";